import * as React from "react";
import { ReactComponent as Cross } from "./images/cross.inline.svg";
import styles from "./styles.module.scss";

const RouteBuilder = ({ text, value, onChange }) => {
  const formId = React.useId();

  return (
    <label htmlFor={formId} className={styles["route-builder"]}>
      <span className={styles.marker}>{text}:</span>
      <input
        id={formId}
        className={styles.input}
        value={value}
        onChange={(event) => {
          onChange(event.target.value);
        }}
      />
      {value && <Cross onClick={() => onChange("")} />}
    </label>
  );
};

export default RouteBuilder;
